import React, { useCallback } from 'react';

import DialogContent from 'components/DialogContent';
import { H2 } from 'components/Heading';
import { Threads } from 'components/icons';
import { ModalFooterButton } from 'components/Modal';
import { Step } from 'components/SteppedModal';
import useThreadsAuthenticator, {
  UseThreadsAuthenticatorConfig,
} from 'hooks/useThreadsAuthenticator';
import { block } from '../utils';
import { ThreadsPostModalSteps } from './types';

interface UseAuthorizationStepConfig
  extends Pick<UseThreadsAuthenticatorConfig, 'onAuthSuccess' | 'onError'> {
  onAuth: () => void;
}

export default function useAuthorizationStep({
  onAuth,
  onAuthSuccess,
  onError,
}: UseAuthorizationStepConfig): Step<ThreadsPostModalSteps> {
  const { authenticate, authenticating } = useThreadsAuthenticator({
    force: true,
    onAuthSuccess,
    onError,
  });

  const handleAuthenticate = useCallback((): void => {
    onAuth();
    authenticate();
  }, [authenticate, onAuth]);

  return {
    id: 'authorization',
    fluidFooterButtons: true,
    component: (
      <DialogContent
        title="Let's add your account"
        details={
          <H2>
            We'll quickly send you to Meta so you can give us permission to add
            videos to your Threads account.
          </H2>
        }
        icon={<Threads className={block('icon')} />}
        detailsClassName={block('details')}
      />
    ),
    renderFooterButtons: ({ submit }) => [
      <ModalFooterButton
        {...submit}
        theme="submit"
        disabled={authenticating}
        onClick={handleAuthenticate}
      >
        <span>Sign in with Threads</span>
      </ModalFooterButton>,
    ],
  };
}
